<template>
  <MainLayout>
    <v-layout style="padding: 1em" justify-center column fill-height>
      <AccountInformation />
    </v-layout>
  </MainLayout>
</template>

<script>
import AccountInformation from "./AccountInformation";

export default {
  metaInfo: {
    title: "Profile",
    meta: [
      {
        name: "Profile",
        content: "profile, user account"
      }
    ]
  },

  components: {
    AccountInformation
  }
};
</script>
